import PropTypes from 'prop-types'
import { isEmpty, isNullOrUndefined } from 'utils'
import { forwardRef } from 'react'

const ErrorText = forwardRef(
  ({ tag: Tag = 'span', error, style = {} }, ref) =>
    error !== false &&
    !isNullOrUndefined(error) &&
    !isEmpty(error) && (
      <Tag ref={ref} className="txt_error" style={style}>
        {error}
      </Tag>
    )
)

ErrorText.displayName = 'ErrorText'
ErrorText.propTypes = {
  tag: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.bool,
  ]),
  style: PropTypes.object,
}

export default ErrorText
